import { lazy } from 'react';

export const ConfirmGemsTransactionVault = lazy(() => import('./ConfirmGemsTransactionVault.component'));
